<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.8535 9.094H16.8895C15.1235 9.085 13.6655 7.622 13.6655 5.838V2.698C13.6655 2.455 13.4725 2.25 13.2215 2.25H8.06649C5.66249 2.25 3.71249 4.229 3.71249 6.647V17.158C3.71249 19.693 5.75949 21.75 8.26949 21.75H15.9435C18.3475 21.75 20.2875 19.79 20.2875 17.372V9.533C20.2875 9.289 20.0945 9.094 19.8535 9.094Z"
      fill="white" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.6031 12.169L13.3021 15.138C13.1801 15.296 12.9991 15.398 12.8011 15.423C12.6031 15.446 12.4031 15.392 12.2471 15.269L10.1591 13.631L8.27009 16.086C8.12209 16.278 7.90009 16.379 7.67409 16.379C7.51509 16.379 7.35409 16.328 7.21809 16.223C6.89009 15.971 6.82909 15.5 7.08109 15.171L9.43109 12.116C9.55309 11.958 9.73409 11.855 9.93209 11.83C10.1291 11.804 10.3311 11.86 10.4891 11.983L12.5791 13.623L14.4171 11.25C14.6701 10.924 15.1411 10.862 15.4691 11.117C15.7971 11.37 15.8571 11.841 15.6031 12.169Z"
      fill="white" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.0163 7.67101C17.6893 7.67801 18.6243 7.68101 19.4173 7.67801C19.8233 7.67701 20.0293 7.18701 19.7483 6.89101C19.2393 6.35701 18.5303 5.61201 17.8183 4.86401C17.1033 4.11301 16.3853 3.35901 15.8633 2.81101C15.5743 2.50801 15.0703 2.71601 15.0703 3.13601V5.70501C15.0703 6.78301 15.9493 7.67101 17.0163 7.67101Z"
      fill="white" />
  </svg>
</template>
